import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import styles from "./SummaryQuestion.module.css";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";

export default function SummaryQuestion(props) {
  const { label } = props;
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className={styles.summaryQuestion}>
                <CheckBoxOutlinedIcon color="primary" />
                <Typography
                    classes={styles.summaryValue}
                    variant="body1"
                    gutterBottom
                >
                    {label || ""}
                </Typography>
            </div>
        </Grid>
    );
}
